import { useNavigate } from 'react-router-dom';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6">
      <div className="max-w-2xl bg-black border border-white rounded-lg shadow-xl p-8">
        <div className="flex items-center mb-6">
          <button
            onClick={() => navigate('/')}
            className="w-10 h-10 rounded-full bg-white text-black flex items-center justify-center shadow-md hover:bg-gray-200 transition duration-300 mr-4"
            aria-label="Back to Home"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-3xl font-bold text-white">Terms and Conditions</h1>
        </div>
        <p className="text-white mb-4">
          By shopping with Layne Red, you agree to our terms. Exchanges are permitted until the third day after successful delivery, only for different sizes. No exchanges will be accepted after this period.
        </p>
        <p className="text-white">
          For damaged products, you may raise a complaint, subject to our strict monitoring to prevent fraud. All orders are processed securely via the Envia API, and your data is shared only with our courier service.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;